import { wireDatePicker } from "../../../shared/date_picker";

export function wireDownloadsPicker(rootEl, onChange) {
  return wireDatePicker({
    rootEl: rootEl || document,
    onChange,
    inputSelector: '#download-range',
    buttonSelector: '[data-chart-type="downloads"][data-chartid="downloadChartID"][data-range]',
    hiddenFromSelector: '#downloads_from',
    hiddenToSelector: '#downloads_to',
    maxDate: 'today',
    // Match Episode Release Performance Comparison hue (light highlight)
    activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
  });
}
